if (!customElements.get('xfun-cookie-preferences')) {
    let bannerRequest;
    const loadNativeBanner = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        return Promise.resolve(window.privacyBanner);
      }
      if (!bannerRequest) {
        bannerRequest = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.async = true;
          script.onload = () => {
            if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
              resolve(window.privacyBanner);
            } else {
              reject(new Error('Cookie preferences unavailable'));
            }
          };
          script.onerror = () => reject(new Error('Cookie preferences unavailable'));
          document.head.appendChild(script);
        }).catch(error => {
          bannerRequest = null;
          throw error;
        });
      }
      return bannerRequest;
    };

    customElements.define('xfun-cookie-preferences', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const button = this.querySelector('button');
        const status = this.querySelector('[role="status"]');
        if (!button || !status) return;
        this.ready = true;
        button.addEventListener('click', async () => {
          if (button.disabled) return;
          const label = button.textContent;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = this.dataset.loading;
          status.hidden = true;
          status.textContent = '';
          let timeout;
          try {
            await Promise.race([
              loadNativeBanner().then(banner => banner.showPreferences()),
              new Promise((resolve, reject) => {
                timeout = setTimeout(() => reject(new Error('Cookie preferences timeout')), 10000);
              })
            ]);
          } catch (error) {
            status.textContent = this.dataset.error;
            status.hidden = false;
          } finally {
            clearTimeout(timeout);
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = label;
          }
        });
      }
    });
  }
